<!-- FIN Header -->
      <div class="container-fluid ladata p-0 mb-3 marginMobile">
        <div class="row g-0">
          <div class="col-lg-2 col-md-4 col-6 lesStats borderRight">
              <div class="card-body dataBody p-2  p-md-4">
                <p class="numberData">{{mouvement?.BLCC}}</p>
                <p>Solde compatible</p>
              </div>
          </div>
          <div class="col-lg-2 col-md-4 col-6 lesStats borderRight">
              <div class="card-body dataBody p-2 p-md-4">
                <p class="numberData">{{mouvement?.DLVOSTC}}</p>
                <p>En-cours livraison</p>
              </div>
          </div>
          <div class="col-lg-2 col-md-4 col-6 lesStats borderRight">
              <div class="card-body dataBody p-2 p-md-4">
                <p class="numberData">{{mouvement?.NIVDLVC}}</p>
                <p>Livré non facture</p>
              </div>
          </div>
          <div class="col-lg-2 col-md-4 col-6 lesStats borderRight">
              <div class="card-body dataBody p-2 p-md-4">
                <p class="numberData">{{mouvement?.NPTINVC}}</p>
                <p>Fact. non compta</p>
              </div>
          </div>
          <div class="col-lg-2 col-md-4 col-6 lesStats borderRight">
              <div class="card-body dataBody p-2 p-md-4">
                <p class="numberData">{{mouvement?.NYTBILC}}</p>
                <p>Portefeuille</p>
              </div>
          </div>
          <div class="col-lg-2 col-md-4 col-6 lesStats ">
              <div class="card-body dataBody p-2 p-md-4">
                <p class="numberData">{{mouvement?.ORDBPIATIC}}</p>
                <p>CMD</p>
              </div>
          </div>
        </div>
      </div>
      <div class="container-lg container-md-fluid mb-5">
        <div class="row">
          <div class="col-12 col-md-4 col-lg-4 col-xl-2">
            <app-dashmenu></app-dashmenu>
          </div>
          <div class="col-12 col-md-4 col-lg-4 col-xl-5">
            <div class="card p-3">
                <div class="chartTitle card-box">Balance âgée</div>
                <canvas #balance height="300px"></canvas>
            </div>
          </div>
          <div class="col-12 col-md-4 col-lg-4 col-xl-5">
            <div class="card p-3">
                <div class="chartTitle">Chiffre d'Affaires</div>
                <canvas #ca id="chart2" height="300px"></canvas>
            </div>
          </div>
        </div>
      </div>
